import {ReactComponent as MainAuthorListBackground} from 'src/assets/Frame.svg';
import {AuthorListCss, ScrollCss} from "../css/Main.style";
import {useNavigate, Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useIsMobile} from "../../../hooks/useIsMobile";

const MainAuthorList = () => {
    const navigate = useNavigate();
    const isMobile = useIsMobile();

    const [authors, setAuthors] = useState<any[]>([]);

    useEffect(() => {
        const jwtToken = localStorage.getItem('jwtToken');
        axios.post(`/api/home/third`, null, {
            headers: {
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then(response => {

                const authorList = Array.isArray(response.data)
                    ? response.data
                    : Array.isArray(response.data.authors)
                        ? response.data.authors
                        : [];


                setAuthors(authorList);
            })
            .catch(error => {
                console.error("Error fetching authors:", error);
            });

    }, []);


    const chunkedAuthors = [];
    for (let i = 0; i < authors.length; i += 4) {
        chunkedAuthors.push(authors.slice(i, i + 4));
    }


    const handleClick = (author: any) => {
        navigate(`/author/authordetails/${author.authorId}`, {
            state: { authorEmail: author.authorEmail }
        });
    };




    return(

<>

        {isMobile ?

                <>
                    <div  className={"flex flex-col w-full  relative m-auto py-[120px] px-0 items-center gap-10"}>

                        <div className={"absolute z-0 top-0 bottom-0  right-0 left-0 "}>
                            <MainAuthorListBackground/>
                        </div>
                        <div
                            className="flex flex-col justify-center z-10 font-medium text-2xl text-black text-center ">
                            <p>북밋과 함께 하고 있는</p>
                            <p>더 많은 <span className="text-main">작가들</span>을 알아 보세요!</p>
                        </div>

                        <div css={ScrollCss} className="flex flex-row z-10 overflow-x-auto w-full gap-10 p-10">
                        {authors.map((author, index) => (
                            <div key={index} className="flex flex-row justify-start  z-1 gap-7  min-w-max w-fit">
                                    <div key={index} className="w-[189px] px-3 py-4 gap-2 flex flex-col justify-center items-center bg-white rounded-[10px] "
                                         style={{ boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)' }}>
                                        <img
                                            src={author.profilePhoto ? `data:image/png;base64,${author.profilePhoto}` : "/img/profile_sam.jpg"}
                                            alt="작가"
                                            className="w-20 h-20 rounded-full object-cover"
                                        />
                                        <div className="flex flex-col justify-center items-center gap-1 w-[200px]">
                                            <span
                                                className="font-bold text-lg text-black mt-3">{author.authorName}</span>
                                            <span className="text-[#4E4E4E] text-sm opacity-60">{author.genre}</span>

                                            <div className="flex flex-row">
                                                {author.bookGender1 && (
                                                    <span
                                                        className="text-[#4E4E4E] text-sm opacity-60">&bull;{author.bookGender1}</span>
                                                )}
                                                {author.bookGender2 && (
                                                    <span
                                                        className="text-[#4E4E4E] text-sm opacity-60">&nbsp;&bull;{author.bookGender2}</span>
                                                )}
                                            </div>

                                            {author.bootTitle ? (
                                                <div className="flex flex-row gap-1.5 items-center">
                                            <span className=" text-sm text-[#4E4E4E]">{'<'}

                                                {
                                                    author.bootTitle.length > 10
                                                        ? author.bootTitle.slice(0, 10) + '...'
                                                        : author.bootTitle
                                                }
                                                {'>'}
                                                {author.bookOtherCount > 0 && ` 외 ${author.bookOtherCount}건`}

                                        </span>
                                                </div>
                                            ) : (
                                                <div className="flex flex-row gap-1.5 items-center">
                                                </div>
                                            )}

                                        </div>

                                        <Link to={`/author/authordetails/${author.authorId}`} state={{ authorEmail: author.authorEmail }}
                                                className="w-[122px] h-[40px] flex justify-center items-center bg-[#E9FFF5] text-main rounded-lg hover:bg-main  hover:text-white hover:shadow-lg transition-all duration-200 text-inherit no-underline">
                                            <span className="text-base font-bold">자세히 보기</span>
                                        </Link>
                                    </div>
                            </div>
                        ))}
                        </div>
                        <button onClick={() => navigate('/authorlist')}
                                className="w-[260px] z-10  h-[64px] shadow-md  font-namsan font-bold text-main text-lg flex hover:bg-main hover:shadow-lg transition-all duration-200 hover:text-white justify-center items-center rounded-3xl border-[1px] border-main ">
                            작가 리스트 더 보기
                        </button>


                    </div>


                </>

            :

            <>
                <div css={AuthorListCss}>
                    <div className="authorListBackgroud">
                        <MainAuthorListBackground/>
                    </div>
                    <div
                        className="flex flex-col justify-center z-10 font-semibold text-3xl text-black text-center gap-3">
                            <p>북밋과 함께 하고 있는</p>
                            <p>더 많은 <span className="text-main">작가들</span>을 알아 보세요!</p>
                        </div>
                        {chunkedAuthors.map((authorGroup, index) => (
                            <div key={index} className="authorList">
                                {authorGroup.map((author, authorIndex) => (
                                    <div key={authorIndex} className="author flex flex-col justify-between">
                                        <img
                                            src={author.profilePhoto ? `data:image/png;base64,${author.profilePhoto}` : "/img/profile_sam.jpg"}
                                            alt="작가"
                                            style={{borderRadius: "150px", height: "122px"}}
                                            className="w-full object-cover"
                                        />
                                        <div className="flex flex-col justify-center items-center gap-1 w-[200px]">
                                            <span
                                                className="font-bold text-lg text-black mt-3">{author.authorName}</span>
                                            <span className="text-[#4E4E4E] text-sm opacity-60">{author.genre}</span>

                                            <div className="flex flex-row">
                                                {author.bookGender1 && (
                                                    <span
                                                        className="text-[#4E4E4E] text-sm opacity-60">&bull;{author.bookGender1}</span>
                                                )}
                                                {author.bookGender2 && (
                                                    <span
                                                        className="text-[#4E4E4E] text-sm opacity-60">&nbsp;&bull;{author.bookGender2}</span>
                                                )}
                                            </div>

                                            {author.bootTitle ? (
                                                <div className="flex flex-row gap-1.5 items-center">
                                            <span className=" text-sm text-[#4E4E4E]">{'<'}

                                                {
                                                    author.bootTitle.length > 10
                                                        ? author.bootTitle.slice(0, 10) + '...'
                                                        : author.bootTitle
                                                }



                                                {'>'}

                                                {author.bookOtherCount > 0 && ` 외 ${author.bookOtherCount}건`}

                                        </span>
                                                </div>
                                            ) : (
                                                <div className="flex flex-row gap-1.5 items-center">
                                                </div>
                                            )}

                                        </div>

                                        <Link to={`/author/authordetails/${author.authorId}`} state={{ authorEmail: author.authorEmail }}
                                                className="w-[122px] h-[40px] flex justify-center items-center bg-[#E9FFF5] text-main rounded-lg hover:bg-main  hover:text-white hover:shadow-lg transition-all duration-200 text-inherit no-underline">
                                            <span className="text-base font-bold">자세히 보기</span>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        ))}
                        <button onClick={() => navigate('/authorlist')}
                                className="w-[260px] z-10  h-[64px] shadow-sm  font-namsan font-bold text-main text-lg flex hover:bg-main hover:shadow-lg transition-all duration-200 hover:text-white justify-center items-center rounded-3xl border-[1px] border-main ">
                            작가 리스트 더 보기
                        </button>

                    </div>


                </>


        }

</>
    )
}

export default MainAuthorList;
